
import { EP_ADD_SHOP, EP_DELETE_SHOP, EP_EDIT_SHOP, EP_SHOP_LIST } from '../constants/endpointConstants';
import api from './Api';

const getAllShops = async () => {
    const response = await api.get(EP_SHOP_LIST);
    return response.data;
}

const addShop = async (formData) => {
    const response = await api.post(EP_ADD_SHOP, formData);
    return response.data;
};

const editShop = async (formData) => {
    const response = await api.post(EP_EDIT_SHOP, formData);
    return response.data;
};

const deleteShop = async (formData) => {
    const response = await api.post(EP_DELETE_SHOP, formData);
    return response.data;
};

export {getAllShops, addShop, editShop, deleteShop}